"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GA4EventSubContent = void 0;
var GA4EventSubContent;
(function (GA4EventSubContent) {
    GA4EventSubContent["AccountOverview"] = "Account overview";
    GA4EventSubContent["OrderOverview"] = "Order overview";
    GA4EventSubContent["Profile"] = "Profile";
    GA4EventSubContent["Settings"] = "Settings";
})(GA4EventSubContent || (exports.GA4EventSubContent = GA4EventSubContent = {}));
//# sourceMappingURL=GA4EventSubContent.js.map